
/**
 * @fileOverview Button Controller module definition
 * Last Modified: 10/19/2017
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/ButtonController',['require','jquery','lib/Util','GlobalEventDispatcher','GlobalResizeListener'],function (require) {
        var $ = require('jquery'),
            util = require('lib/Util'),
            GlobalEventDispatcher = require('GlobalEventDispatcher'),
            GlobalResizeListener = require('GlobalResizeListener');

        require(['domReady!'], function (doc) {

            $debug('**** Button Set Up Started **** ', 'mmmButtons'); //syntax: $debug(message, urlParam);
            var selector = '.MMM--btn:not(.MMM--btn_noAnimation)';

            if(SETTINGS.theme==='unicorn' || SETTINGS.theme==='lion' || SETTINGS.theme==='hippo'){

                //force buttons to be capitals
                if(SETTINGS.allCaps !== false){
                    $('.MMM--btn,.MMM--ctaBtn').addClass('mix-MMM--btn_allCaps');
                }
                $(selector).not('.mix-MMM--btn_fullWidth').addClass('mix-MMM--btn_fullWidthMobileOnly');

                $debug('Applying Fancy Buttons', 'mmmButtons');
                $(selector).each(function (i,element) {
                    $debug('Found Button #' + (i + 1), 'mmmButtons');
                    new ButtonController($(element));
                });

                //allow dynamic buttons to be added to page. Requires jQuery selector to be passed in
                window.updateMMMButtons = function(sel){
                    if (!sel){
                        $debug('selector not set... setting it to ' + selector, 'mmmButtons');
                        sel = selector;
                    }
                    else{
                        $debug('selector set to ' + sel, 'mmmButtons');
                    }
                    $(sel).not('.mix-MMM--btn_fullWidth').addClass('mix-MMM--btn_fullWidthMobileOnly');

                    if(SETTINGS.allCaps !== false){
                        $('.MMM--btn,.MMM--ctaBtn').addClass('mix-MMM--btn_allCaps');
                    }

                    $(sel).not('.MMM--btn_noAnimation').each(function (i,element) {
                        $debug('Found Button #' + (i + 1), 'mmmButtons', 'mmmButtons');
                        new ButtonController($(element));
                    });

                };
            }
            else {
                $debug('SETTINGS.theme was found wanting... no fancy buttons will be added', 'mmmButtons');
            }
        });

       /**
         * This sets up scrollorama effects.
         *
         * @class ButtonController
         * @param {jQuery} $element A reference to the containing DOM element
         * @constructor
         */
        var ButtonController = function ($element) {

            this.$element = $element;   //store element as property of main object

            /**
             * A reference to the global event dispatcher, provided by the application.
             *
             * @property eventDispatcher
             * @type {}
             * @private
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher(); // event dispatcher that will call the event, provided by the application

            /**
             * A reference to the global resize listener.
             *
             * @property getResizeListener
             * @type {}
             * @private
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            this.init(); //initialize component
        };

        /**
         * Initializes the UI Component View
         *
         * @method init
         * @returns {ButtonController}
         * @private
         */
        ButtonController.prototype.init = function () {
            var self = this;

            if (self.$element.hasClass('unicornButtonActive')){
                $debug('button already active... resetting it', 'mmmButtons');
                self.destroy();
            }

            if (self.checkButtonType() === true){
                $debug('Button is on approved list. Continue.', 'mmmButtons');
                this
                .setOptions()
                .setupHandlers()
                .checkButtonWidth()
                .build();
            }
            else {
                $debug('Button isn\'t on approved list. Abort.', 'mmmButtons');
                return false;
            }

            return this;
        };

        /**
         * Checks the buttons to see if it's on the exception list to prevent the fancy button style
         *
         * @method checkButtonType
         * @returns {true|false}
         * @private
         */
        ButtonController.prototype.checkButtonType = function () {
            var self = this;

            if (self.$element.hasClass('MMM--btn_psn')){
                return false;
            }

            if (self.$element.hasClass('MMM--btn_filter')){
                return false;
            }

            if (self.$element.hasClass('MMM--btn_actionItem')){
                return false;
            }

            if (self.$element.hasClass('MMM--tagBtn')){
                return false;
            }

            if (self.$element.hasClass('MMM--mobileSearchBtn')){
                return false;
            }

            if (self.$element.hasClass('MMM--searchBtn')){
                return false;
            }

            //else
            return true;
        };

        /**
         * Sets up Handlers
         *
         * @method setupHandlers
         * @returns {true|false}
         * @private
         */
        ButtonController.prototype.setupHandlers = function () {
            var self = this;
            // removed on 10/19/2017 making forms unusable on widow resize
            //this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.update.bind(this));

            self.$element.bind('update', function(newValues) {
                self.update();
            });

            if (self.$element.hasClass('MMM--submitButton')){
                //self.$element.click(function(){
                //added touchstart event for devices to support form submit handler
                self.$element.on('touchstart click keydown', function(e) {
                    if(e.which === 13 || e.which === 1){
                    $debug('submit link clicked', 'mmmButtons');
                    $(this).parents('form').first().submit();
                    $(this).parents('div .js-modalTrigger.MMM--isActive').find('a.js-closeLink').focus();
                    return false;   
                    }
                    
                });
            }

            if (self.$element.hasClass('MMM--cancelButton')){
                self.$element.click(function(){
                    $debug('cancel button pressed', 'mmmButtons');
                    $(this).parents('form')[0].reset();
                    return false;
                });
            }
            return this;
        };

        /**
         * Sets up Handlers
         *
         * @method update
         * @returns {true|false}
         * @private
         */
        ButtonController.prototype.update = function () {
            var self = this;
            $debug('in update method', 'mmmButtons');
            self.destroy();
            self.build();
        };

        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         *
         * @method setOptions
         * @returns {ButtonController}
         * @private
         */
        ButtonController.prototype.setOptions = function () {
            var options = this.$element.data().options;
            var defaults = {
                speed: 300
            };

            this.settings = $.extend({}, defaults, options);    //merge defaults with data-options object
            $debug('     ButtonController Options ', 'mmmButtons');
            // $debug('     HTML SETTINGS Settings: ' + $printObj(options),'mmmButtons');
            $debug('     Default Settings: ' + $printObj(defaults),'mmmButtons');
            $debug('     Combined Settings: ' + $printObj(this.settings),'mmmButtons');
            return this;
        };

        /**
         * Builds the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method enable
         * @returns {ButtonController}
         * @public
         */
        ButtonController.prototype.build = function () {
            var self = this;
            var w, h;
            var extraClass = '';
            var $t = self.$element;

            $t.addClass('unicornButtonActive');

            if ($t.hasClass('MMM--btn_secondary')){
                extraClass = 'MMM--secondaryOverlay';
            }
            else if ($t.hasClass('MMM--btn_tertiary')){
                extraClass = 'MMM--tertiaryOverlay';
            }

            $t.attr('data-color', $t.css('background-color'));


            ////Hover event
            var deviceTypeList=['Linux armv7l','iPhone','iPad'];
            var deviceName=typeof(navigator.platform)==='undefined'?'':navigator.platform;
            if(deviceTypeList.indexOf(deviceName) < 0){
                self.$element.hover(function(){
                    $debug('hover in', 'mmmButtons');
                    var $self = $(this);
                    w = $self.outerWidth();
                    h = $self.outerHeight();
                    $self.append('<span class="MMM--btnOverlay ' + extraClass + '" style="height: 0px;" data-height="' + (w * 0.7) + '"></span>');
                    var $el = $self.find('.MMM--btnOverlay');
                    $self.css('background', 'none');
                    $el.animate({
                        height : $el.attr('data-height')
                    }, {queue:false, duration:300});
                }, function(){
                    $debug('hover out', 'mmmButtons');
                    var $self = $(this);
                    var $el = $self.find('.MMM--btnOverlay');
                    $el.animate({
                        height: 0
                    },
                                {
                        queue:false,
                        duration:300,
                        complete: function(){
                            $debug('removing $el', 'mmmButtons');
                            $self.removeAttr('style');
                            $el.remove();
                        }
                    });
                });
            }else {
                    if(self.$element.hasClass('MMM--btn_tertiary')){
                        self.$element.css('color','#FFF');
                    }
                    else{
                        self.$element.css('color','#000');
                    }
                }

            return this;
        };

        /**
         * Destroys/Resets the component
         * Performs any event binding to handlers
         *
         * @method destroy
         * @returns {ButtonController}
         * @public
         */
        ButtonController.prototype.destroy = function () {
            $debug('in destroy', 'mmmButtons');
            var self = this;
            var $t = self.$element;
            $t.unbind('mouseenter mouseleave');

            // If the button was a submit button we assigned a click event to it, that needs to be removed as well before being rebuilt
            if($t.hasClass('MMM--submitButton')) {
                $t.unbind('click');
            }

            $t.removeClass('unicornButtonActive');
            $t.removeAttr('data-color');
            $t.find('.MMM--btnOverlay').remove();
            return this;
        };
        
        
         /**
         * Checks for button within rG-70-CTALinks, .rG-73-ContentCTA and rG-72-ContactBar
         * Checks for total width of buttons, if longer than parent container width, add class 'MMM--fullWidthLayout'
         * If total button width is less than parent container width, add class 'MMM--initialWidthLayout'
         * If there is only one button, add class 'MMM--fullWidthLayout'
         */
        
        ButtonController.prototype.checkButtonWidth = function () {
            var self = this;
            var $t = self.$element;
            var ctaLinkDPLs = '.rG-70-CTALinks, .rG-73-ContentCTA';
            var ctaContactBar = '.rG-72-ContactBar';
            var ctaIconicButton = $('.MMM--btn_noAnimation');
            var totalWidth = 0;
            var buttonCount = [];
            
            // Looping through buttons to see if contained in rICO-107-CTALinks
            if((ctaIconicButton).parents(ctaLinkDPLs).length){
                $t = ctaIconicButton;
            }
            
            // Looping through buttons to see if contained in rG-70/rG-73
                if($t.parents(ctaLinkDPLs).length){

                    // Determine number of buttons and available width of parent container
                    var numOfButtons = $t.parents('ul').find('li').length;
                    var availableWidth = $t.parents('.MMM--vListtohList').width();
                    
                    $debug("*************rG-70/73 LOOP START****************", 'mmmButtonWidth');
                    $debug("Available Width: " + availableWidth, 'mmmButtonWidth');
                    $debug("Number of Buttons: " + numOfButtons, 'mmmButtonWidth'); 

                        // For only one button, add class 'MMM--fullWidthLayout'
                        if(numOfButtons == 1){
                            $t.parents('ul').find('li').addClass('MMM--fullWidthLayout');
                        }

                        // Checks for parent classes to see if assigned classes are already present
                        if($t.parents('ul').find('li').hasClass('MMM--fullWidthLayout') || $t.parents('ul').find('li').hasClass('MMM--initialWidthLayout')) {

                              $debug("Parent item has looped once...exit", 'mmmButtonWidth');

                        } else {

                              // Adds each button width to buttonCount array
                              $t.parents('ul').find('li').each(function() { 
                                  buttonCount.push($(this).outerWidth(true)); 
                              });

                              // Calculates the total width of buttonCount array
                              totalWidth = buttonCount.reduce(add, 0);
                              function add(a, b) {
                                    return a + b;
                              }

                              $debug("Button Width Array: " + buttonCount, 'mmmButtonWidth');
                              $debug("Total Width of combined buttons: " + totalWidth, 'mmmButtonWidth');

                              // Checks whether totalWidth exceeds availableWidth and adds proper class
                              if(totalWidth >= availableWidth) {
                                  $t.parents('ul').find('li').addClass('MMM--fullWidthLayout');
                                  totalWidth = 0;
                                } else {
                                  $t.parents('ul').find('li').addClass('MMM--initialWidthLayout');
                                  totalWidth = 0;
                                }
                        }

                }
            
                // Looping through buttons to see if contained in rG-72
                if($t.parents(ctaContactBar).length){

                    // Determine number of buttons and available width of parent container
                    var numOfButtons = $t.parents('.MMM--leftTileLayout').find('.MMM--tileLayout-col').length;
                    var availableWidth = $t.parents('.MMM--tileLayout-col_50').width();
                    
                    $debug("*************rG-72 LOOP START****************", 'mmmButtonWidth');
                    $debug("Available Width: " + availableWidth, 'mmmButtonWidth');
                    $debug("Number of Buttons: " + numOfButtons, 'mmmButtonWidth'); 

                        // For only one button, add class 'MMM--fullWidthLayout'
                        if(numOfButtons == 1){
                            $t.parents('.MMM--leftTileLayout').find('.MMM--tileLayout-col').addClass('MMM--fullWidthLayout');
                        }
                    
                        // Checks for parent classes to see if assigned classes are already present
                        if($t.parents('.MMM--leftTileLayout').find('.MMM--tileLayout-col').hasClass('MMM--fullWidthLayout') || $t.parents('.MMM--leftTileLayout').find('.MMM--tileLayout-col').hasClass('MMM--initialWidthLayout')) {

                            $debug("Parent item has looped once...exit", 'mmmButtonWidth');

                        } else {

                              // Adds each button width to buttonCount array
                              $t.parents('.MMM--leftTileLayout').find('.MMM--tileLayout-col').each(function() { 
                                  buttonCount.push($(this).outerWidth(true)); 
                              });

                              // Calculates the total width of buttonCount array
                              totalWidth = buttonCount.reduce(add, 0);
                              function add(a, b) {
                                    return a + b;
                              }

                              $debug("Button Width Array: " + buttonCount, 'mmmButtonWidth');
                              $debug("Total Width of combined buttons: " + totalWidth, 'mmmButtonWidth');

                              // Checks whether totalWidth exceeds availableWidth and adds proper class
                              if(totalWidth >= availableWidth) {
                                  $t.parents('.MMM--leftTileLayout').find('.MMM--tileLayout-col').addClass('MMM--fullWidthLayout');
                                  totalWidth = 0;
                                } else {
                                  $t.parents('.MMM--leftTileLayout').find('.MMM--tileLayout-col').addClass('MMM--initialWidthLayout');
                                  totalWidth = 0;
                                }
                        }

                }

            return this;
         };
        
    }); //end define

}(MMMRequire));
